import axios from '../utils/ajax'
// 导出
export const exportExcel = params => axios.post('/managementPlatform/thailand/thailandExcelExport',params)

//获取导出列表
export const getExportList = params => axios.get('/managementPlatform/thailand/queryThailandExportTask',{params})



// WEBPACK FOOTER //
// ./src/api/export.js